import React, { useState } from "react";
import classnames from "classnames";

import "./CpcButton.scss";

import CpcInputField from "../InputField/CpcInputField";
import Button from "../Button/Button";
import SvgInline from "../SvgInline";

import CrossIcon from "!svg-inline-loader!./images/cross.svg";
import CheckIcon from "!svg-inline-loader!./images/check.svg";

const CpcButton = ({
  value,
  onChange,
  readonly,
  error,
  mode,
  onModeChange
}) => {
  const [localValue, setValue] = useState(value);

  const onApply = () => {
    onChange(localValue);
  };

  return (
    <div
      className={classnames("cpc-button", {
        readonly: readonly,
        error: error,
        edit: mode == "edit"
      })}
    >
      {mode == "button" ? (
        <div
          className="cpc-button__label"
          onClick={() => !readonly && onModeChange("input")}
        >
          <span className="cpc-button__rub">₽</span>
          <span className="cpc-button__value">{value}</span>
        </div>
      ) : (
        <div className="cpc-button__edit">
          <CpcInputField
            value={localValue}
            onChange={e => setValue(e.target.value)}
          />
          <Button
            color="light-blue"
            className="cpc-button__ok"
            onClick={onApply}
          >
            <SvgInline src={CheckIcon} className="cpc-button__icon" />
          </Button>
          <Button
            color="light-blue"
            onClick={() => onModeChange("button")}
            className="cpc-button__cancel"
          >
            <SvgInline src={CrossIcon} className="cpc-button__icon" />
          </Button>
        </div>
      )}
    </div>
  );
};

CpcButton.defaultProps = {
  readonly: false,
  error: false
};

export default CpcButton;
